import { render, staticRenderFns } from "./pieChart2.vue?vue&type=template&id=7a4f90e2&"
import script from "./pieChart2.vue?vue&type=script&lang=js&"
export * from "./pieChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports